export const TRANSITION_DURATION = 300;

export const CHECK_ACTIVITY_PATH = '/home/reception/checkinactivity';
